import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';

import { EnvironmentService, ErableHttpService } from '@ecm/consumer';
import { KenobiParams, Status } from '@ecm/tracker';

import { DashboardReco } from '../business/api/reco/dashboardReco';
import { KenobiTrackingCode } from '../business/model/tracking/kenobiTrackingCode-model';
import { TrackingService } from './tracking.service';

@Injectable({
    providedIn: 'root',
})
export class ContractRecoService {
    public constructor(
        private readonly environmentService: EnvironmentService,
        private readonly http: ErableHttpService,
        private readonly trackingService: TrackingService,
    ) {}

    /**
     * ContractReco query
     * @param {KenobiTrackingCode} kenobiTrackingCode Kenobi tracking info for kosi
     * @param {string} pageId Transaction properties for BCO monitoring
     * @returns {Observable<DashboardReco[]>}
     */
    public getContractReco(kenobiTrackingCode: KenobiTrackingCode, pageId: string): Observable<DashboardReco[]> {
        return this.requestInitContractReco(kenobiTrackingCode, pageId);
    }

    /**
     * XHR nested requests to CONTRACT_RECO endpoint
     * @param {KenobiTrackingCode} kenobiTrackingCode Kenobi tracking info for kosi
     * @param {string} pageId Transaction properties for BCO monitoring
     * @returns {Observable<any>}
     */
    private requestInitContractReco(kenobiTrackingCode: KenobiTrackingCode, pageId: string): Observable<any> {
        const env = this.environmentService.instant();
        if (!env.API.DASHBOARD.CONTRACT_RECO_URL) {
            return of([]);
        } else {
            return this.http
                .get(env.API.DASHBOARD.CONTRACT_RECO_URL, {
                    feature: 'dashboard',
                    pageId,
                    functionality: kenobiTrackingCode['functionality'],
                    partner: 'ZCE',
                    service: 'contractsReco',
                })
                .pipe(
                    catchError(() => {
                        this.trackingService.trackKenobi(
                            new KenobiParams(
                                kenobiTrackingCode['functionality'],
                                kenobiTrackingCode['rubric'],
                                Status.KOSI,
                            ),
                            pageId,
                        );
                        return of([]);
                    }),
                );
        }
    }
}
